import { Colaborador } from '@/store/catalogos/colaborador';
import { UnidadModel } from '@/store/catalogos/unidad';
import { properties } from '@/utils/properties';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class CatalogoUnidadService {
  private readonly baseUrl = properties.URL_CATALOGOS + 'unidades';

  constructor(private http: HttpClient) { }

  getAll(): Observable<UnidadModel[]> {
    return this.http.get<UnidadModel[]>(this.baseUrl, httpOptions);
  }

  create(unidad: UnidadModel): Observable<UnidadModel> {
    return this.http.post<UnidadModel>(this.baseUrl, unidad, httpOptions);
  }

  update(unidad: UnidadModel): Observable<UnidadModel> {
    return this.http.put<UnidadModel>(`${this.baseUrl}/${unidad.idUnidad}`, unidad, httpOptions);
  }


}
